
























































































































































































































































































































































// Vue
import Vue from "vue";
// Vuex
import { mapActions, mapGetters } from "vuex";
// Models
import {
  JobSiteModel,
  ContactModel,
  CustomerModel,
  UpdateJobSiteModel,
  UpdateContactModel,
  UpdateCustomerModel
} from "@/core/api/apiClient";

// Vuelidate
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

// Components
import ConfirmationDialog from "@/core/components/content/_dialogs/ConfirmationDialog.vue";
import CreateCustomerDialog from "@/views/dispatch/customers/_dialogs/customer/CreateCustomerDialog.vue";
import CreateContactDialog from "@/views/dispatch/customers/_dialogs/contact/CreateContactDialog.vue";
import UpdateContactDialog from "@/views/dispatch/customers/_dialogs/contact/UpdateContactDialog.vue";
import CreateJobsiteDialog from "@/views/dispatch/customers/_dialogs/job-site/CreateJobsiteDialog.vue";
import UpdateJobsiteDialog from "@/views/dispatch/customers/_dialogs/job-site/UpdateJobsiteDialog.vue";
// services
import AdminService from "@/views/admin/Admin.service";

export default Vue.extend({
  name: "Customers",
  components: {
    ConfirmationDialog,
    CreateCustomerDialog,
    CreateContactDialog,
    UpdateContactDialog,
    CreateJobsiteDialog,
    UpdateJobsiteDialog
  },

  data() {
    return {
      isLoading: false,
      isContactsLoading: false,
      isJobsitesLoading: false,

      search: "",
      isCustomerSelected: false,
      isEditingCustomer: false,

      selectedCustomer: {} as CustomerModel,
      businessAddress: "",
      databaseId: "",
      email: "",
      ext: undefined as string | undefined | null,
      isCOD: false,
      name: "",
      phone: "",
      notes: "",

      // Customer data
      customersData: [] as CustomerModel[],
      selectedCustomerContactsData: [] as ContactModel[],
      selectedCustomerJobsitesData: [] as JobSiteModel[],

      contacts: [] as ContactModel[],
      jobsites: [] as JobSiteModel[]
    };
  },

  mounted() {
    this.getAllCustomers();
  },

  mixins: [validationMixin],

  validations: {
    name: { required }
  },

  methods: {
    ...mapActions("customers", {
      //fetchCustomers: "fetchCustomers",
      //pushCustomers: "pushCustomers",
      setCustomer: "setCustomer"
      // removeCustomer: "removeCustomer"
    }),

    ...mapActions("appMessages", {
      ADD_ERROR_MESSAGE: "ADD_ERROR_MESSAGE",
      ADD_SUCCESS_MESSAGE: "ADD_SUCCESS_MESSAGE"
    }),

    getAllCustomers(): void {
      this.customersData = [] as CustomerModel[];
      this.isLoading = true;

      AdminService.getAllCustomers(this.currentUser.clientId).then((data: CustomerModel[]) => {
        if (!data) return;
        this.customersData = data;
        this.isLoading = false;
      });
    },

    getAllCustomerContacts(customerId: string): void {
      this.isContactsLoading = true;
      AdminService.getAllCustomerContacts(this.currentUser.clientId, customerId).then(
        (data: ContactModel[]) => {
          if (!data) return;
          this.selectedCustomerContactsData = data;
          this.isContactsLoading = false;
        }
      );
    },

    getAllCustomerJobsites(customerId: string): void {
      this.isJobsitesLoading = true;
      AdminService.getAllCustomerJobsites(this.currentUser.clientId, customerId).then(
        (data: JobSiteModel[]) => {
          if (!data) return;
          this.selectedCustomerJobsitesData = data;
          this.isJobsitesLoading = false;
        }
      );
    },

    createCustomer(newCustomer: CustomerModel): void {
      this.setCustomer(newCustomer)
        .then((cust) => {
          this.getAllCustomers();
          this.setSelectedCustomer(cust);
          this.ADD_SUCCESS_MESSAGE(`Customer successfully created.`);
        })
        .catch((error) => {
          console.log(error);
          this.ADD_ERROR_MESSAGE(`Error creating customer. Please try again.`);
        });
    },

    deleteCustomer(deletedCustomer: CustomerModel): void {
      AdminService.deleteCustomer(this.currentUser.clientId, deletedCustomer.customerId!)
        .then((response: any) => {
          if (!response) return;
          this.getAllCustomers();
          this.ADD_SUCCESS_MESSAGE(`Customer successfully deleted.`);
          this.isCustomerSelected = false;
          this.isEditingCustomer = false;
        })
        .catch((error) => {
          console.log(error);
          this.ADD_ERROR_MESSAGE(`Error deleting customer. Please try again.`);
        });
    },

    updateCustomer(): void {
      const payload: UpdateCustomerModel = new UpdateCustomerModel({
        email: this.email ?? null,
        businessAddress: this.businessAddress ?? null,
        ext: this.ext ?? undefined,
        isCOD: this.isCOD,
        lastUsedTimestamp: new Date(),
        name: this.name,
        notes: this.notes ?? null,
        phone: this.phone ?? null
      });
      AdminService.updateCustomer(this.currentUser.clientId, this.databaseId, payload)
        .then((response: any) => {
          if (!response) return;
          this.getAllCustomers();
          this.ADD_SUCCESS_MESSAGE(`Customer successfully updated.`);
          this.isEditingCustomer = false;
        })
        .catch((error) => {
          console.log(error);
          this.ADD_ERROR_MESSAGE(`Error updating customer. Please try again.`);
        });
    },

    setSelectedCustomer(selectedCustomer: CustomerModel): void {
      if (this.selectedCustomer === selectedCustomer) {
        // Customer is already selected, deselect
        this.selectedCustomer = {} as CustomerModel;
        this.isCustomerSelected = false;
        return;
      }
      this.selectedCustomer = selectedCustomer;
      this.isCustomerSelected = true;
      this.isEditingCustomer = false;
      this.businessAddress = selectedCustomer.businessAddress!;
      this.databaseId = selectedCustomer.customerId!;
      this.email = selectedCustomer.email!;
      this.isCOD = selectedCustomer.isCOD!;
      this.name = selectedCustomer.name;
      this.phone = selectedCustomer.phone!;
      this.ext = selectedCustomer.ext;
      this.notes = selectedCustomer.notes!;
      this.getAllCustomerContacts(selectedCustomer.customerId!);
      this.getAllCustomerJobsites(selectedCustomer.customerId!);
    },

    cancelSelectedCustomer(): void {
      this.isCustomerSelected = true;
      this.businessAddress = this.selectedCustomer.businessAddress!;
      this.databaseId = this.selectedCustomer.customerId!;
      this.email = this.selectedCustomer.email!;
      this.isCOD = this.selectedCustomer.isCOD!;
      this.name = this.selectedCustomer.name;
      this.phone = this.selectedCustomer.phone!;
      this.ext = this.selectedCustomer.ext;
      this.notes = this.selectedCustomer.notes!;
      this.isEditingCustomer = false;
    },

    createContact(payload: UpdateContactModel): void {
      AdminService.createCustomerContact(
        this.currentUser.clientId,
        this.selectedCustomer.customerId!,
        payload
      )
        .then((response: any) => {
          if (!response) return;
          this.getAllCustomerContacts(this.selectedCustomer.customerId!);
          this.ADD_SUCCESS_MESSAGE(`Contact successfully created.`);
        })
        .catch((error) => {
          console.log(error);
          this.ADD_ERROR_MESSAGE(`Error creating contact. Please try again.`);
        });
    },

    updateContact(payload: ContactModel): void {
      AdminService.updateCustomerContact(
        this.currentUser.clientId,
        this.selectedCustomer.customerId!,
        payload
      )
        .then((response: any) => {
          if (!response) return;
          this.getAllCustomerContacts(this.selectedCustomer.customerId!);
          this.ADD_SUCCESS_MESSAGE(`Contact successfully updated.`);
        })
        .catch((error) => {
          console.log(error);
          this.ADD_ERROR_MESSAGE(`Error updating contact. Please try again.`);
        });
    },

    deleteContact(payload: ContactModel): void {
      AdminService.deleteCustomerContact(
        this.currentUser.clientId,
        this.selectedCustomer.customerId!,
        payload.contactId!
      )
        .then((response) => {
          if (!response) return;
          this.getAllCustomerContacts(this.selectedCustomer.customerId!);
          this.ADD_SUCCESS_MESSAGE(`Contact successfully deleted.`);
        })
        .catch((error) => {
          console.log(error);
          this.ADD_ERROR_MESSAGE(`Error deleting contact. Please try again.`);
        });
    },

    createJobSite(payload: UpdateJobSiteModel): void {
      AdminService.createCustomerJobSite(
        this.currentUser.clientId,
        this.selectedCustomer.customerId!,
        payload
      )
        .then((response: any) => {
          if (!response) return;
          this.getAllCustomerJobsites(this.selectedCustomer.customerId!);
          this.ADD_SUCCESS_MESSAGE(`Job site successfully created.`);
        })
        .catch((error) => {
          console.log(error);
          this.ADD_ERROR_MESSAGE(`Error creating job site. Please try again.`);
        });
    },

    updateJobSite(payload: JobSiteModel): void {
      AdminService.updateCustomerJobSite(
        this.currentUser.clientId,
        this.selectedCustomer.customerId!,
        payload.jobSiteId,
        payload
      )
        .then((response: any) => {
          if (!response) return;
          this.getAllCustomerJobsites(this.selectedCustomer.customerId!);
          this.ADD_SUCCESS_MESSAGE(`Job site successfully updated.`);
        })
        .catch((error) => {
          console.log(error);
          this.ADD_ERROR_MESSAGE(`Error updating job site. Please try again.`);
        });
    },

    deleteJobSite(payload: JobSiteModel): void {
      AdminService.deleteCustomerJobSite(
        this.currentUser.clientId,
        this.selectedCustomer.customerId!,
        payload.jobSiteId!
      )
        .then((response) => {
          if (!response) return;
          this.getAllCustomerJobsites(this.selectedCustomer.customerId!);
          this.ADD_SUCCESS_MESSAGE(`Job site successfully deleted.`);
        })
        .catch((error) => {
          console.log(error);
          this.ADD_ERROR_MESSAGE(`Error deleting job site. Please try again.`);
        });
    }
  },

  computed: {
    ...mapGetters({
      data: "customers/items",
      currentUser: "currentUser"
    }),
    /**
     * Filters Customers via search bar
     * @author Nick Brahimir
     */
    filteredCustomers(): any {
      if (!this.search) return this.customersData;

      return this.customersData.filter((element: CustomerModel) => {
        return element.name?.toLowerCase().includes(this.search?.toLowerCase());
      });
    },

    /**
     * Parses any Name errors.
     *
     * @author Nick Brahimir
     */
    nameErrors(): string[] {
      const errors: string[] = [];
      if (!this.$v.$dirty) {
        return errors;
      }

      !this.$v.name.required && errors.push("Customer name is required");

      return errors;
    }
  }
});
